var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kpt-detail-pane",style:({ width: 'calc(100% - ' + _vm.paneWidth + 'px)'})},[_c('router-view',{attrs:{"name":"detail"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }